import { useState, useEffect } from 'react';

export interface ThemeColors {
  primary: string;
  primaryLight: string;
  primaryDark: string;
  textOnPrimary: string;
  hexAlpha: (hex: string, alpha: number) => string;
}



function readColorsWithHelper(): ThemeColors {
  const style = getComputedStyle(document.documentElement);
  return {
    primary: style.getPropertyValue('--color-primary').trim() || '#fbbf24',
    primaryLight: style.getPropertyValue('--color-primary-light').trim() || '#fde68a',
    primaryDark: style.getPropertyValue('--color-primary-dark').trim() || '#f59e0b',
    textOnPrimary: style.getPropertyValue('--color-text-on-primary').trim() || '#000000',
    hexAlpha,
  };
}

export function useThemeColor(): ThemeColors {
  const [colors, setColors] = useState<ThemeColors>(readColorsWithHelper);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setColors(readColorsWithHelper());
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    });
    return () => observer.disconnect();
  }, []);

  return colors;
}

// Helper: hex color with opacity (e.g. hexAlpha('#fbbf24', 0.2) => 'rgba(251,191,36,0.2)')
export function hexAlpha(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  if (h.length !== 6) return `rgba(251,191,36,${alpha})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
